const getPosition = (
  el: HTMLElement
): {
  top: number
  left: number
  width: number
  height: number
} => {
  const { top, left, width, height } = el.getBoundingClientRect()
  return { top, left, width, height }
}

export default getPosition
